/**
 * Sidebar Date created filter: binds RmaListFiltersStore date range, Mixpanel, and chip label
 * formatting to RmaListFilterControl via filterControlDataProps.
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { useDateTimeFormattingParams } from "../../../../../../../hooks/use-datetime-formatting-params";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../../utils/manage-returns-list-mixpanel";
import RmaListFiltersStore from "../../../../../rma-list-page/stores/rma-list-filters-store";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/components/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterDateRange: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const { timeZone } = useDateTimeFormattingParams();
    const dateRange = rmaListFiltersStore.dateRange;
    const selectedLabel = rmaListFiltersStore.getDateRangeSelectedChipLabel(timeZone);

    return (
        <RmaListFilterControl
            label={getTranslation("FILTERS_DATE_CREATED", scope)}
            selectedLabel={selectedLabel}
            disabled={disabled}
            onOpen={() => trackManageReturnsListEvent("d&_filter_date_created", MANAGE_RETURNS_DESIGN_VERSION.V2)}
            onClear={() => rmaListFiltersStore.setDateRange("")}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.DATE_RANGE,
                value: dateRange,
                timeZone,
                getInputValues: rmaListFiltersStore.getDateRangeInputValues,
                onChange: (isoRange) => {
                    rmaListFiltersStore.setDateRange(isoRange);
                    trackManageReturnsListEvent("d&_apply_date_filter", MANAGE_RETURNS_DESIGN_VERSION.V2);
                },
            }}
        />
    );
});

export default RmaListFilterDateRange;
